import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { MedicoPCSMOService } from '@/core/api/sicom-api/servicos/pessoa-fisica/pcmso/pcmso.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { MedicoPCSMORequest, MedicoPCSMOResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/pcmso/pcmso.model';

@Injectable({ providedIn: 'root' })
export class PcmsoServicosService {
    constructor(
        private api: MedicoPCSMOService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: MedicoPCSMORequest, context?: HttpContext): Observable<MedicoPCSMOResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
